<template>
  <div class="table">
    <artmisads-table
      :columns="columns"
      row-key="id"
      :data-source="props.dataList"
      :scroll="{x: 1000,y: 500}"
      :pagination="{
        total: props.tableTotal,
        current: props.params.page,
        pageSize: props.params.size,
        showSizeChanger: true
      }"
      :expandedRowKeys="props.expandedRowKeys"
      :expand="onExpand"
      :change="onChangePage"
      rowClassName="table-item"
      table-layout="fixed"
    >
      <template #bodyCell="{ column, text, record }">
        <template v-if="column.name === 'showCurrency'">
          {{text ? AMAZON_CURRENCY_MAPPER[props.marketplace] : ''}}{{text}}
        </template>
        <template v-if="column.name === 'reportDateTimestamp'">
          {{moment(text).format('YYYY-MM-DD')}}
        </template>
        <template v-if="column.name === 'more'">
          <a-tooltip placement="top">
            <template #title>
              <span>View Details</span>
            </template>
            <img src="../../../../assets/images/img/edit.png" @click="() => onClickTableDetail(record)" alt="" class="icon chart-icon" aria-hidden="true">
          </a-tooltip>
          <a-tooltip placement="top">
            <template #title>
              <span>View Reports</span>
            </template>
            <svg @click="() =>  onClickTableChart(record)" class="icon chart-icon" aria-hidden="true">
              <use xlink:href="#icon-chart"></use>
            </svg>
          </a-tooltip>
          
        </template>
        <template v-if="column.name === 'conversionsRate'&&!record.children">
          {{ text ? (text * 100).toFixed(2).replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1') + '%' : '0' }}
        </template>
        <template v-if="column.name === 'brandName'">
          <a class="brand-title"  target="_blank" :href="`/publisher/brands/${record.brandId}`">  
            <div class="brand-img-show" :style="record?.brandLogoImageUrl?{'background':'#ffffff'}:''">
              <img :src="record.brandLogoImageUrl" alt="" v-if="record.brandLogoImageUrl">
            </div>
            <div  class="brand-font">
              <span style="text-decoration: underline;">{{ record.brandName }}</span>
            </div>
          </a>
        </template>
      </template>

      <template #summary>
        <a-table-summary-row>
          <a-table-summary-cell >&nbsp</a-table-summary-cell>
          <!-- <a-table-summary-cell >--</a-table-summary-cell> -->
          <a-table-summary-cell class="fixed-left">Total</a-table-summary-cell>
          <a-table-summary-cell>
            <a-typography-text>{{ props.tagNumParams.totalDetailPageViews }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell>
            <a-typography-text>{{ props.tagNumParams.totalAddToCart }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell>
            <a-typography-text>{{ props.tagNumParams.totalConversions }}</a-typography-text>
          </a-table-summary-cell>
          <!-- <a-table-summary-cell>
            <a-typography-text>{{ props.tagNumParams.totalConversionsRate ? (props.tagNumParams.totalConversionsRate * 100).toFixed(2).replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1') + '%' : 0}}</a-typography-text>
          </a-table-summary-cell> -->
          <a-table-summary-cell>
            <a-typography-text>{{props.tagNumParams.totalDiscountedSalesAmount ? AMAZON_CURRENCY_MAPPER[props.marketplace] : ''}}{{ props.tagNumParams.totalDiscountedSalesAmount }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell>
            <a-typography-text>{{props.tagNumParams.totalCommissionAmount ? AMAZON_CURRENCY_MAPPER[props.marketplace] : ''}}{{ props.tagNumParams.totalCommissionAmount }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell>
            <a-typography-text></a-typography-text>
          </a-table-summary-cell>
        </a-table-summary-row>
      </template>
    </artmisads-table>
  </div>
</template>
<script setup lang="jsx">
  import moment from 'moment';
  import { onMounted, ref, watch, computed } from 'vue';

  import { AMAZON_CURRENCY_MAPPER } from '~/contants/common';
  import { reportsApi } from '~/server/index';

  const props = defineProps(['dataList', 'marketplace', 'tableTotal', 'params','expandedRowKeys', 'setExpandedRowKeys', 'setParams', 'onClickTableChart','onClickTableDetail', 'tagNumParams']);

  const onChangePage = (data, filters, sorter) => {
    const { current, pageSize } = data;
    let newParams = { ...props.params };
    newParams.page = current;
    newParams.size = pageSize;
    if (sorter) {
      const { field, order } = sorter;
      newParams.sortField = field;
      newParams.sortDirection = order === 'ascend' ? 'asc' : 'desc';
    } 
    props.setParams(newParams);
  }

  const onExpand = (expanded, record) => {
    let newExpandedRowKeys = [...props.expandedRowKeys];
    if (expanded) {
      // 展开：添加到数组中
      if (!newExpandedRowKeys.includes(record.id)) {
        newExpandedRowKeys.push(record.id);
      }
    } else {
      // 收起：从数组中移除
      newExpandedRowKeys = newExpandedRowKeys.filter(key => key !== record.id);
    }
    props.setExpandedRowKeys(newExpandedRowKeys);
  }

  const columns = [
    {
      title: 'Primary Id',
      dataIndex: 'primaryTrackingIds',
      width: 200,
      fixed: 'left',
    },
    {
      title: 'Sub Id',
      dataIndex: 'subTrackingId',
      width: 200,
      fixed: 'left',
    },
    {
      title: 'DPVs',
      dataIndex: 'detailPageViews',
      width: 80,
      sorter: true,
    },
    {
      title: 'Add to Cart',
      dataIndex: 'addToCart',
      width: 130,
      sorter: true,
    },
    {
      title: 'Conversions',
      dataIndex: 'conversions',
      width: 120,
      sorter: true,
    },
    // {
    //   name: 'conversionsRate',
    //   title: 'Conversions Rate',
    //   dataIndex: 'conversionsRate',
    //   width: 180,
    //   sorter: true,
    // },
    {
      title: 'Sales for Commission',
      dataIndex: 'discountedSalesAmount',
      name: 'showCurrency',
      width: 240,
      sorter: true,
    },
    {
      title: 'Commission',
      dataIndex: 'commissionAmount',
      name: 'showCurrency',
      width: 120,
      sorter: true,
    },
    {
      title: 'More',
      name: 'more',
      dataIndex: 'commissionAmount',
      width: 100,
      fixed: 'right',
    },
  ]

</script>
<style lang="less" scoped>
  :deep(.ant-table) {
    .brand-title{
      display: flex;
      align-items: center;
      .brand-font{
        word-break: break-all;
        flex: 1;
        margin-left: 12px;
        font-weight: 500;
        color: var(--dark-1);
        letter-spacing: 0.4px;
        line-height: 22px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-decoration: underline;
      }
      .brand-img-show{
        width: 56px;
        height: 56px;
        background: var(--bg-gray-2);
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        :deep(img){
        
          height: 100%;
          object-fit: contain;
        }
      }
      
    }
    .chart-icon {
      cursor: pointer;
      width: 20px;
      height: 20px;
    }
    .chart-icon:nth-child(2) {
      margin-left: 10px;
    }
    .inactive-commission {
      color: var(--dark-4);
    }
    .status-text {
      text-transform: capitalize;
    }
  }
  .fixed-left {
    left: 0px;
    z-index: 1;
    position: sticky;
    padding-left: 86px;
  }  
</style>
